import React from 'react';
import PropTypes from 'prop-types';
import FieldValue from './FieldValue';
import { Button } from '../index';
import './OnOffField.scss';



export default function OnOffField({ style, label, value, onChange, options, error }) {
  return (
    <FieldValue
      style={style}
      className="form-on-off-field"
      label={label}
      error={error}
    >
      <div className="btn-container">
        {options.map((option) => {
          return (
            <Button
              key={option.value}
              type={(value || []).includes(option.value)
                ? 'primary'
                : 'simple'}
              onClick={(e) => {
                e.preventDefault();
                const newValue = value.slice();
                if (value.includes(option.value)) {
                  newValue.splice(value.indexOf(option.value), 1);
                } else {
                  newValue.push(option.value);
                }
                onChange({
                  target: {
                    value: newValue,
                  },
                });
              }}
            >{option.label}</Button>
          );
        })}
      </div>
    </FieldValue>
  );
}

OnOffField.propTypes = {
  style: PropTypes.shape(),
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.node.isRequired,
  })).isRequired,
  label: PropTypes.string,
  value: PropTypes.node,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.node,
};

OnOffField.defaultProps = {
  style: {},
  label: '',
  value: [],
  error: null,
};
